module.exports = __webpack_public_path__ + "img/daishouHigh.52110547.png";